import { IFormViewForm } from 'components/FormView';

const SupplierDetails: IFormViewForm = {
  id: 'SupplierDetails',
  layout: {
    rows: 2,
    columns: 3
  },
  fields: [
    {
      id: '1',
      type: 'PAPER_CONTAINER',
      visible: true,
      props: {
        label: 'Supplier',
        name: 'Supplier',
        fullWidth: true
      },
      position: {
        row: 1,
        col: 1
      },
      children: [
        {
          id: '1',
          type: 'TEXT_FIELD',
          visible: true,
          props: {
            label: 'Supplier',
            name: 'SupplierDisplay',
            size: 'small'
          },
          layout: {
            row: 1,
            xs: {
              col: 12
            },
            sm: {
              col: 12
            },
            md: {
              col: 3
            },
            lg: {
              col: 3
            }
          }
        },
        {
          type: 'TEXT_FIELD',
          props: {
            label: 'Abbreviation',
            name: 'SupplierDisplay',
            size: 'medium'
          }
        },
        {
          id: '3',
          type: 'TEXT_FIELD',
          visible: true,
          props: {
            label: 'Name',
            name: 'SupplierLabel',
            size: 'large'
          }
        },
        {
          id: '4',
          type: 'TEXT_FIELD',
          visible: true,
          props: {
            label: 'Trading as',
            name: 'TradingAs',
            size: 'large',
            required: false
          }
        },
        {
          type: 'TOGGLE_FIELD',
          props: {
            label: 'Supplier active',
            name: 'SupplierActive',
            required: false
          }
        },
      ]
    },
    {
      type: 'PAPER_CONTAINER',
      props: {
        label: 'Postal address',
        name: 'address',
        required: true,
      },
      children: [
        {
          type: 'ADDRESS_BLOCK_EX',
          props: {
            name: 'address'
          }
        }
      ],
      position: {
        row: 2,
        col: 1
      },
    },
    {
      type: 'PAPER_CONTAINER',
      props: {
        label: 'General contact details',
        name: 'contactDetails',
        required: true,
      },
      position: {
        row: 1,
        col: 2
      },
      children: [
        {
          type: 'ACTION_FIELD',
          props: {
            label: 'Phone',
            name: 'Phone',
            required: false,
            size: 'medium',
            action: {
              iconName: 'Phone',
            }
          }
        },
        {
          type: 'ACTION_FIELD',
          props: {
            label: 'Fax',
            name: 'Fax',
            required: false,
            size: 'medium',
            action: {
              iconName: 'Phone',
            }
          }
        },
        {
          type: 'ACTION_FIELD',
          props: {
            label: 'Mobile',
            name: 'Mobile',
            required: false,
            size: 'medium',
            action: {
              iconName: 'Phone',
            }
          }
        },
        {
          type: 'ACTION_FIELD',
          props: {
            label: 'Email',
            type: 'email',
            name: 'Email',
            required: false,
            size: 'large',
            action: {
              iconName: 'Mail',
            }
          }
        },
        {
          type: 'ACTION_FIELD',
          props: {
            label: 'Web',
            name: 'Web',
            required: false,
            size: 'large',
            action: {
              iconName: 'Language',
            }
          }
        }
      ]
    },
    {
      type: 'CONTACT_BLOCK',
      props: {
        label: 'Primary contacts',
        name: 'PrimaryContactsValue',
        variant: 'supplier'
      },
      position: {
        row: 1,
        col: 3
      },
    }
  ]
};
export default SupplierDetails;
